package com.dignicate.web.domain

/**
 * Language as a sealed class for type safety across the codebase.
 * Add cases as needed.
 */
sealed class Language(val code: String) {
    object Ja : Language("ja")
    object En : Language("en")
    object System : Language("system")
    data class Other(val otherCode: String) : Language(otherCode)

    override fun toString(): String = code

    companion object {
        fun fromCode(code: String?): Language = when (code?.lowercase()) {
            "ja" -> Ja
            "en" -> En
            "system" -> System
            null -> System
            else -> Other(code)
        }
    }
}

